export default {
    // A
    adminRoleDescription: 'Admins can create and delete channels, manage users, and have access to all software tools.',

    // C
    create: {},

    // E
    emailMagicLink: 'Email Magic link',
    enterPassword: 'Enter password',

    // I
    inviteColleagues: 'Invite colleagues',
    inviteWithEmail: 'Invite with email',
    inviteWithEmailText: 'Your colleagues will get an email that gives them access to your channel.',
    inviteYourColleagues: 'Invite Your Colleagues',
    inviteYourColleaguesText: 'Bring your team onboard and collaborate seamlessly. Your colleagues will receive an email granting them access to your channel.',
    inviteYourPartners: 'Invite Your External Community',
    inviteYourPartnersText: 'Expand your reach by inviting key partners to collaborate. Your invitees will receive a VIP Guest Pass, granting them exclusive access to the platform.',

    // M
    marketScaleAdminRoleDescription: 'MarketScale Admins have access to all software tools, can create and delete channels, and manage users.',

    // P
    pleaseSelectApprover: 'Please select approver',
    pleaseSelectColleague: 'Please select colleague',
    pleaseSelectExpert: 'Please select expert',
    profilePhotoSuccessfullyDeleted: 'Profile photo successfully deleted',

    // S
    standardRoleDescription: 'Standard users have access to all software tools to create and collaborate on media with colleagues and contributors.',

    // U
    updateUser: 'Update User',
    userInfo: 'User info',

    // V
    viewAsUser: 'View as {firstName} {lastName}',
    vipGuestRoleDescription: 'VIP Guests can create content, but cannot publish it.',
}
